/* eslint-disable no-undef */
import palette from 'theme/palette';

const envVar = (eVar: string): string => {
  return process.env[eVar] || window[eVar];
};

export const APP_API = envVar('REACT_APP_API');

export const APP_ENV = envVar('REACT_APP_ENV');

export const REACT_APP_BETA = envVar('REACT_APP_BETA') === 'true';

export const REACT_APP_RFID = envVar('REACT_APP_RFID') === 'true';

export const REACT_DISABLE_RESET_UNIT = envVar('REACT_DISABLE_RESET_UNIT') === 'true';

export const REACT_APP_TAX = envVar('REACT_APP_TAX') === 'true';

export const REACT_APP_SMS = envVar('REACT_APP_SMS') === 'true';

export const REACT_APP_LOYALTY = envVar('REACT_APP_LOYALTY') === 'true';

export const REACT_APP_PORT = envVar('REACT_APP_PORT') === 'true';

export const mapboxApiAccessToken = envVar('REACT_APP_MAPBOX_KEY');

export const googleAPIKey = envVar('REACT_APP_GOOGLE_API_KEY');

export const googleAnalyticsAPIKey = envVar('REACT_APP_GOOGLE_ANALYTICS');

export const apiConfig = {
  auth: `${process.env.REACT_APP_AUTH_API || APP_API}/auth-service`,
  user_mgt: `${process.env.REACT_APP_USER_MGMT_API || APP_API}/user-mgt`,
  asset_mgt: `${process.env.REACT_APP_ASSET_MGMT_API || APP_API}/asset-mgt`,
  asset: `${process.env.REACT_APP_ASSET_API || APP_API}/asset`,
  ocpi: `${process.env.REACT_APP_OCPI_API || APP_API}/ocpi`,
  ocpp: `${process.env.REACT_APP_OCPP_API || APP_API}/ocpp`,
  cpo: `${process.env.REACT_APP_CPO_API || APP_API}/cpo`,
  site_energy: `${APP_API || process.env.REACT_APP_SEM_API}/site-energy`,
  oadr: `${APP_API || process.env.REACT_APP_OADR_API}/oadr`,
  env: `${APP_ENV || process.env.NODE_ENV}`,
  analytics: googleAnalyticsAPIKey || 'G-L0XBYN3SJM',
  rfid: `${process.env.REACT_APP_AMP_API || APP_API}/fleet`
};

export const autoHideDuration = 5000;

export const googleAnalyticsConfig = process.env.REACT_APP_GOOGLE_ANALYTICS;

export const geoLocationLink = 'https://maps.googleapis.com/maps/api/geocode/json?address';

export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 92,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32
};
export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32
};
export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20
};

export const PRIMARY_COLOR = [
  // DEFAULT
  {
    name: 'default',
    ...palette.light.primary
  },
  // PURPLE
  {
    name: 'purple',
    lighter: '#EBD6FD',
    light: '#B985F4',
    main: '#7635dc',
    dark: '#431A9E',
    darker: '#200A69',
    contrastText: '#fff'
  },
  // CYAN
  {
    name: 'cyan',
    lighter: '#D1FFFC',
    light: '#76F2FF',
    main: '#1CCAFF',
    dark: '#0E77B7',
    darker: '#053D7A',
    contrastText: palette.light.grey[800]
  },
  // BLUE
  {
    name: 'blue',
    lighter: '#CCDFFF',
    light: '#6697FF',
    main: '#0045FF',
    dark: '#0027B7',
    darker: '#00137A',
    contrastText: '#fff'
  },
  // ORANGE
  {
    name: 'orange',
    lighter: '#FEF4D4',
    light: '#FED680',
    main: '#FDA92D',
    dark: '#B66816',
    darker: '#793908',
    contrastText: palette.light.grey[800]
  },
  // RED
  {
    name: 'red',
    lighter: '#FFE3D5',
    light: '#FFC1AC',
    main: '#FF3030',
    dark: '#B71833',
    darker: '#7A0930',
    contrastText: '#fff'
  }
];
export const DEFAULT = PRIMARY_COLOR[0];
export const PURPLE = PRIMARY_COLOR[1];
export const CYAN = PRIMARY_COLOR[2];
export const BLUE = PRIMARY_COLOR[3];
export const ORANGE = PRIMARY_COLOR[4];
export const RED = PRIMARY_COLOR[5];

export const ROWS_PER_PAGE = 50;

export const ALL_RECORDS_COUNT = 10000;
